import { Button, Card } from "antd";
import "../styles/index.css";

const PendingPageTGN = () => {
  return (
    <div className="tgnpdcl-main-wrapper-telangana">
      <div className="tgnpdcl-center-container">
        <div className="tgnpdcl-center-box-bill-status-page">
          <Card
            className="tgnpdcl-service-number-card-status-page"
            cover={
              <div className="tgnpdcl-payment-status">
                <div className="tgnpdcl-tel-north-logo-main">
                  <img
                    alt="TGNPDCL"
                    className="tgnpdcl-logo"
                    src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tel-north-main-logo.svg"
                    style={{ width: '51.5px', height: '46px' }}
                  />
                  <span className="tgnpdcl-elecricity-title">
                    NORTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED
                  </span>
                </div>
              </div>
            }
          >
            <div className="tgnpdcl-pending-message-container">
              <div className="tgnpdcl-pending-message-box">
                <div className="tgnpdcl-pending-message-inner">
                  <p className="tgnpdcl-pending-message-english">
                    Dear user, your payment has not been completed. Please click on the button below and try again.
                  </p>
                  <p className="tgnpdcl-pending-message-telugu">
                    ప్రియమైన వినియోగదారుడు, మీ చెల్లింపు పూర్తి కాలేదు. దయచేసి క్రింద ఉన్న బటన్‌పై క్లిక్ చేసి మళ్లీ ప్రయత్నించండి.
                  </p>
                  <div className="tgnpdcl-receipt-buttons-tg">
                    <Button
                      className="tgnpdcl-make-another-payment-tg"
                      size="large"
                      block
                      onClick={() => {
                        window.location.href = "/TGNPDCL/Billpay";
                      }}
                    >
                      Click here !
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <img
            alt="poweredby-easebuzz-logo-status-page"
            className="tgnpdcl-poweredby-easebuzz-logo-status-page"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
          />
        </div>
      </div>
    </div>
  );
};

export default PendingPageTGN;